import { PortalTelemetryScreen } from '../../../app/telemetry/portalTelemetryScreens';
import { portalScreenContext } from '../../../app/telemetry/portalTelemetry';
import { usePortalScreen } from '../../../app/telemetry/usePortalTelemetry';
import { Box, Typography } from "@mui/material";
import { useMemo, useState } from "react";
import { useHistory } from "react-router-dom";
import AppPagination from "../../../app/components/AppPagination";
import { AppPathEnum } from "../../../app/enums/appPathEnum";
import { PcsEventInstanceDto } from "../../../app/models/events/pcsEventInstanceDto";
import EventCard from "../components/EventCard";

interface Props { events: PcsEventInstanceDto[]; }

function eventTime(event: PcsEventInstanceDto) {
    const date = event.startDate ? new Date(event.startDate) : null;
    return date && !Number.isNaN(date.getTime()) ? date.getTime() : Number.MAX_SAFE_INTEGER;
}

export default function UpcomingEventsPage({ events }: Props) {
    const history = useHistory();
    const [startIndex, setStartIndex] = useState(0);
    const [endIndex, setEndIndex] = useState(0);
    const sortedEvents = useMemo(() => [...events].sort((a, b) => eventTime(a) - eventTime(b)), [events]);
    const visibleEvents = sortedEvents.slice(startIndex, endIndex);
    let lastYear: number | undefined;

    usePortalScreen(portalScreenContext(PortalTelemetryScreen.UpcomingEventsPage), undefined, true);

    return (
        <Box component="main" sx={{ bgcolor: '#fff', minHeight: 530, px: { xs: 2.5, sm: 5 }, py: { xs: 3, sm: 2.75 } }}>
            <Box aria-hidden="true" sx={{ display: 'flex', alignItems: 'flex-start', height: 22, mb: 1.5 }}>
                <Box sx={{ width: 16, borderTop: '4px solid', borderColor: 'primary.main' }} />
                <Box sx={{ width: 21, height: 21, borderTop: '4px solid', borderLeft: '4px solid', borderColor: 'primary.main', transform: 'rotate(-135deg)', mt: -1 }} />
                <Box sx={{ width: 43, borderTop: '4px solid', borderColor: 'primary.main' }} />
            </Box>
            <Typography component="h1" sx={{ color: '#252d38', fontSize: { xs: 35, sm: 42 }, fontWeight: 700, lineHeight: 1.15, mb: { xs: 7, sm: 8 } }}>
                Upcoming events
            </Typography>

            {visibleEvents.length === 0 ? <Typography sx={{ color: '#252d38', py: 2 }}>No events found.</Typography> : visibleEvents.map(event => {
                const parsedDate = event.startDate ? new Date(event.startDate) : null;
                const year = parsedDate && !Number.isNaN(parsedDate.getTime()) ? parsedDate.getFullYear() : undefined;
                const showYear = year !== undefined && year !== lastYear;
                lastYear = year;
                return (
                    <Box key={event.eventInstanceId ?? event.eventId ?? `${event.description}-${eventTime(event)}`}>
                        {showYear && <Typography component="h2" sx={{ color: 'primary.main', fontSize: 18, fontWeight: 700, lineHeight: 1.2, borderBottom: '1px solid #d2d2d2', pb: 0.5, mb: 2.5 }}>{year}</Typography>}
                        <EventCard event={event} onClick={event.eventInstanceId ? () => history.push(
                            `${AppPathEnum.PCS_CALENDAR_OF_ACTIVITIES}/${event.eventInstanceId}${window.location.search}`
                        ) : undefined} />
                    </Box>
                );
            })}

            <AppPagination startIndex={setStartIndex} endIndex={setEndIndex} recordsCount={sortedEvents.length} perPageItemCount={5} />
        </Box>
    );
}
